import { MessageRequest, UseLocalApiOptions } from "../types";

export const useCommunicate = ({ context }: UseLocalApiOptions) => ({
  createMessage: (request: MessageRequest) => {
    // eslint-disable-next-line no-alert
    alert(`Creating communicate message:
      matter id: ${request.matterId || context?.matterId}
      contact ids: ${request.contactIds?.join(", ") || "Not set"}
      staff ids: ${request.staffIds?.join(", ") || "Not set"}
      message: ${request.message}
    `);
  },
  sendMessage: (request: MessageRequest) => {
    // eslint-disable-next-line no-alert
    alert(`Sending communicate message:
      matter id: ${request.matterId || context?.matterId}
      contact ids: ${request.contactIds?.join(", ") || "Not set"}
      staff ids: ${request.staffIds?.join(", ") || "Not set"}
      message: ${request.message}
    `);
  },
});
